window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};

window.FazendaRP.Pages.Safra = {
    init: async function () {
        this.injectStyles();

        const mainContent = document.getElementById('main-content');
        mainContent.innerHTML = `
            <div style="display:flex; flex-direction:column; height:100%; background: linear-gradient(135deg, #f8fafc 0%, #e0f2e9 100%);">
                
                <!-- V4 Header -->
                <div style="padding: 20px 30px; background: rgba(255,255,255,0.95); backdrop-filter: blur(10px); border-bottom: 1px solid #e2e8f0; box-shadow: 0 2px 8px rgba(0,0,0,0.04);">
                    <div style="display:flex; justify-content:space-between; align-items:center;">
                        <div>
                            <h1 style="margin:0; font-size:1.6rem; color:#0f172a; font-weight:700; display:flex; align-items:center; gap:12px;">
                                <i class="fas fa-wheat-awn" style="color:#15803d;"></i> Gestão de Safra
                            </h1>
                            <p style="color: #64748b; margin: 5px 0 0 0; font-size:0.95rem;">Controle de Produção, Contratos e Logística</p>
                        </div>
                        <div style="display:flex; gap:12px;">
                            <button class="btn-v4 btn-secondary" onclick="window.FazendaRP.Pages.Safra.Config.openModal()">
                                <i class="fas fa-cog"></i> Configurações
                            </button>
                        </div>
                    </div>
                </div>

                <!-- V4 Tabs -->
                <div style="padding: 0 30px; background: white; border-bottom: 1px solid #e2e8f0;">
                    <div class="tabs-v4">
                        <button class="tab-v4 active" onclick="window.FazendaRP.Pages.Safra.switchTab('dashboard', this)">
                            <i class="fas fa-chart-line"></i> Painel de Resultados
                        </button>
                        <button class="tab-v4" onclick="window.FazendaRP.Pages.Safra.switchTab('romaneios', this)">
                            <i class="fas fa-truck-loading"></i> Entradas (Romaneios)
                        </button>
                        <button class="tab-v4" onclick="window.FazendaRP.Pages.Safra.switchTab('contratos', this)">
                            <i class="fas fa-file-signature"></i> Contratos de Venda
                        </button>
                    </div>
                </div>

                <!-- Content Area -->
                <div style="flex:1; overflow-y:auto; padding:25px 30px;">
                    <div id="view-dashboard" class="view-section active"></div>
                    <div id="view-romaneios" class="view-section"></div>
                    <div id="view-contratos" class="view-section"></div>
                </div>
            </div>
        `;

        // Init Dashboard by default
        if (window.FazendaRP.Pages.Safra.Dashboard) await window.FazendaRP.Pages.Safra.Dashboard.init();
    },

    injectStyles: function () {
        if (document.getElementById('safra-v4-styles')) return;
        const style = document.createElement('style');
        style.id = 'safra-v4-styles';
        style.innerHTML = `
            .tabs-v4 { display: flex; gap: 5px; }
            .tab-v4 {
                background: none; border: none; padding: 14px 24px; font-size: 0.95rem; font-weight: 600;
                color: #64748b; cursor: pointer; border-bottom: 3px solid transparent; transition: all 0.2s;
                display: flex; align-items: center; gap: 8px;
            }
            .tab-v4:hover { color: #15803d; background: rgba(21,128,61,0.05); }
            .tab-v4.active { color: #15803d; border-bottom-color: #15803d; }
            .tab-v4 i { font-size: 1rem; }
            
            .view-section { display: none; animation: fadeIn 0.3s; }
            .view-section.active { display: block; }
            
            @keyframes fadeIn {
                from { opacity: 0; transform: translateY(5px); }
                to { opacity: 1; transform: translateY(0); }
            }
            
            .btn-v4 {
                padding: 10px 20px; border-radius: 8px; border: none; font-weight: 600; cursor: pointer;
                display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; font-size: 0.9rem;
            }
            .btn-secondary { background: white; border: 1px solid #e2e8f0; color: #475569; }
            .btn-secondary:hover { background: #f8fafc; border-color: #cbd5e1; }
            .btn-primary { background: #15803d; color: white; box-shadow: 0 2px 8px rgba(21,128,61,0.3); }
            .btn-primary:hover { background: #166534; transform: translateY(-1px); }
        `;
        document.head.appendChild(style);
    },

    switchTab: async function (tabId, btnElement) {
        // UI Toggle
        document.querySelectorAll('.view-section').forEach(el => el.classList.remove('active'));
        document.querySelectorAll('.tab-v4').forEach(el => el.classList.remove('active'));

        document.getElementById('view-' + tabId).classList.add('active');
        if (btnElement) btnElement.classList.add('active');

        // Lazy Load Logic
        if (tabId === 'dashboard') {
            if (window.FazendaRP.Pages.Safra.Dashboard) await window.FazendaRP.Pages.Safra.Dashboard.init();
        }
        else if (tabId === 'romaneios') {
            if (window.FazendaRP.Pages.Safra.Colheita) await window.FazendaRP.Pages.Safra.Colheita.init();
        }
        else if (tabId === 'contratos') {
            if (window.FazendaRP.Pages.Safra.Contratos) await window.FazendaRP.Pages.Safra.Contratos.init();
        }
    }
};
